import { Field } from "@base-ui/react/field";
import type { ReactNode } from "react";

interface FormFieldProps {
  label?: string;
  hint?: string;
  error?: string;
  disabled?: boolean;
  children: ReactNode;
}

export function FormField({
  label,
  hint,
  error,
  disabled,
  children,
}: FormFieldProps) {
  return (
    <Field.Root invalid={!!error} disabled={disabled} className="relative">
      {label && (
        <Field.Label className="mb-1 block text-sm text-gray-500">
          {label}
        </Field.Label>
      )}

      {children}

      {error && (
        <Field.Error className="mt-1.5 text-xs text-error-500">
          {error}
        </Field.Error>
      )}

      {hint && (
        <Field.Description className="mt-1.5 text-xs text-gray-500">
          {hint}
        </Field.Description>
      )}
    </Field.Root>
  );
}
